module.exports = __webpack_public_path__ + "static/img/SF.bfe7dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/SF.png
// module id = KPYk
// module chunks = 34